import { LessonScreenContentI } from "@/hooks/types";
import { useState } from "react";
import Animation from "../../../Animation";
import { LessonDataI } from "../../../quiz/typesAndEnums";
import LessonHomework from "./LessonHomework";
import LessonNavigationTabs from "./LessonNavigationTabs";
import LessonQuiz from "./LessonQuiz";
import LessonTabsContent from "./LessonTabsContent";
import LessonVideo from "./LessonVideo";

const LessonPageContentMapper = ({
  lessonData,
}: {
  lessonData: LessonDataI;
}) => {
  const [screenContent, setScreenContent] = useState<{
    elementId: string;
    screen: LessonScreenContentI;
  }>({ elementId: "", screen: LessonScreenContentI.QUIZ });

  if (screenContent.elementId) {
    if (screenContent.screen === LessonScreenContentI.QUIZ)
      return (
        <Animation expand={false}>
          <LessonQuiz
            lessonData={lessonData}
            setScreenContent={setScreenContent}
          />
        </Animation>
      );

    if (screenContent.screen === LessonScreenContentI.HW)
      return (
        <Animation expand={false}>
          <LessonHomework
            lessonData={lessonData}
            setScreenContent={setScreenContent}
          />
        </Animation>
      );

    if (screenContent.screen === LessonScreenContentI.VIDEO)
      return (
        <Animation expand={false}>
          <LessonVideo
            lessonData={lessonData}
            videoId={screenContent.elementId}
            setScreenContent={setScreenContent}
          />
        </Animation>
      );
  }

  return (
    <Animation expand={false}>
      <LessonNavigationTabs
        lessonData={lessonData}
        screenContent={screenContent}
        setScreenContent={setScreenContent}
      >
        <LessonTabsContent
          lessonData={lessonData}
          setScreenContent={setScreenContent}
        />
      </LessonNavigationTabs>
    </Animation>
  );

};

export default LessonPageContentMapper;
